import toast from "react-hot-toast";
import translateError from "../translateError";

export default (error: any) => {
  toast.error(translateError(error.data.message), {
    position: 'top-left',
    duration: 5000,
  });
}